import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MusicSurvey from './components/MusicSurvey';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MusicSurvey />
  </React.StrictMode>
);
